import dayjs from 'dayjs';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { STANDARD_DATE_FORMAT_DAYJS } from '@/utils/date-formatters';

interface FilterRangeBarTooltipContentProps {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  /** Clears the filter date range (routes through the store so chips/bar/request stay in sync) */
  onClear: () => void;
}

/**
 * Hover card of the timeline filter range bar: which period the planner
 * filters apply to, plus an X button removing the date range filter.
 */
export function FilterRangeBarTooltipContent({
  startDate,
  endDate,
  onClear,
}: FilterRangeBarTooltipContentProps) {
  const { t } = useTranslation('authenticated.planner');

  return (
    // Inverted surface matching the bar itself: near-black in light theme,
    // near-white in dark theme (fills the tooltip portal's popover wrapper).
    <div className="flex items-center gap-1 bg-primary py-1 pl-3 pr-1 text-sm text-primary-foreground">
      <span>
        {t('filters.dateRangeBar.appliesTo', {
          start: startDate.format(STANDARD_DATE_FORMAT_DAYJS),
          end: endDate.format(STANDARD_DATE_FORMAT_DAYJS),
        })}
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0 text-primary-foreground hover:bg-primary-foreground/15 hover:text-primary-foreground"
        aria-label={t('filters.dateRangeBar.clear')}
        onClick={onClear}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
